<template>
<div>
<TopAppBar
	:leftBtnMode="leftBtnMode"
	:rightBtnMode="rightBtnMode"
	:title="topTitle"
	:leftBtnMethod="leftBtnMethod"
	:rightBtnMethod="rightBtnMethod"
  :hideCategory="false"
	staticMode="true"
></TopAppBar>
<div class="d-flex flex-column" :class="isNoData ? 'vh-100' : 'h-full'">
	<TopAppBarDrawer></TopAppBarDrawer>
					<main class="main-wrapper flex-grow-1">
						<div class="d-flex align-items-center">
								<div class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 fix-header-title d-flex justify-content-center align-items-center">
										{{title}}
								</div>
						</div>
						<div class="divider"></div>
						<!-- subtabs -->
						<NoData v-if="isNoData"></NoData>
						<div class="container container--narrow pdt-30 pdb-26" v-else>
								<div class="mdc-card  mgb-24 pdt-24 pdb-16 pdl-24 pdr-24" v-for="(record, index) in listData" :key="index" :class="{'bg-documentGray': record.isBlocked}">
										<div class="d-flex cursor-pointer" @click="moveToDetail(record)" @keypress="moveToDetail(record)" tabindex="0">
												<div class="list-image-small">
													<img
															v-if="record.auditor.register.profile"
															:src="record.auditor.register.profile"
															class="circle icon52" alt=""
													/>
														<img v-else src="images/avtar.svg" class="circle icon52" alt="">
												</div>
												<div class="flex-grow-1 pdl-16">
														<div class="d-flex justify-content-between">
																<div class="t-body1 mgb-1 font-r mgb-4" :class="{'t-color-bodyGrayB': record.isBlocked}">{{ record.auditor.register.name?$t('3437',{first: record.auditor.register.name.first, last: record.auditor.register.name.last}):''}}</div>
																<div class="t-body3 font-r t-color-bodyGrayA" :class="{'t-color-bodyGrayB': record.isBlocked}">{{ $moment(record.auditor.register.time).format("L") }}</div>
														</div>
														<div class="d-flex user-list-info mgt-4" v-if="record.auditor.register.storeName">
															<div class="t-body3  t-color-bodyGrayA font-r pdr-8 mgr-8 dkk2 font-r" :class="{'t-color-bodyGrayB': record.isBlocked}" v-if="record.auditor.register.storeName">{{ record.auditor.register.storeName }}</div>
															<div class="t-body3  t-color-bodyGrayA font-r pdr-8  mgr-8 font-r" :class="{'t-color-bodyGrayB': record.isBlocked}">{{ record.auditor.register.responsibilityName }}</div>
														</div>
														<div class="d-flex user-list-info mgt-4" v-else>
															<div class="t-body3  t-color-bodyGrayA font-r pdr-8 mgr-8 dkk2 font-r" :class="{'t-color-bodyGrayB': record.isBlocked}">{{ record.auditor.register.storeName ? record.auditor.register.storeName : topTitle }}</div>
														</div>
												</div>
										</div>
										<div class="t-body6 font-r t-color-bodyGrayA mgt-16 l-spacing45 t-line-h-25 cursor-pointer" :class="{'t-color-bodyGrayB': record.isBlocked}" tabindex="0" @click="moveToDetail(record)" @keypress="moveToDetail(record)"
										v-if="record.contents && record.contents.body !== ''" v-html="record.isBlocked ? $t('3814') : listFilter(record.contents.body)">
										</div>
										<div class="d-flex mgt-4 flex-wrap" v-if="!record.isBlocked && record.tags && record.tags.length > 0">
												<div v-for="(tag, i) in record.tags" :key="i" class="pdl-4 pdr-4 b-radius2 mgr-4 mgt-4 t-body3 font-r t-color-contentBlue bg-contentBlueInactive min-h-22 t-center">
														#{{ tag.name }}
												</div>
										</div>
									<div class="user_imgList mgt-16" v-if="!record.isBlocked && record.contents.files.length > 2">
										<a href="javascript:void(0)">
												<img :src="record.contents.files[0].resourceUri" alt />
										</a>
										<a href="javascript:void(0)" >
												<img
														v-if="record.contents.files[1]"
														:src="record.contents.files[1].resourceUri"
														alt
												/>
										</a>
										<a class="more">
												<img
														v-if="record.contents.files[2]"
														:src="record.contents.files[2].resourceUri"
														alt
												/>
												<span v-if="(record.contents.files.length - 3 ) > 0 " >+{{ record.contents.files.length - 3 }}</span>
										</a>
								</div>
								<div class="user_imgList mgt-16" v-if="!record.isBlocked && record.contents.files.length === 2">
										<a href="javascript:void(0)" v-for="(img,index1) in record.contents.files" :key="index1" style="width: 48.9%;padding-top: 48.9%;">
												<img :src="img.resourceUri" alt />
										</a>
								</div>
										<div class="square-image mgt-16" v-if="!record.isBlocked && record.contents.files.length === 1">
												<a href="javascript:void(0)"><img :src="record.contents.files[0].resourceUri" alt=""></a>
										</div>
										<div class="d-flex justify-content-between align-items-center mgt-16 mgb-16" v-if="!record.isBlocked">
												<div class="d-flex flex-grow-1">
														<div class="t-color-bodyGrayB t-helper font-r pdr-24">{{ $t("1430", { str: record.likesCount }) }}</div>
														<div class="t-color-bodyGrayB t-helper font-r pdr-24">{{ $t("1431", { str: record.commentCount }) }}</div>
												</div>
												<div class="t-color-bodyGrayB t-helper font-r ">{{ $t("1432", { str: record.viewCount }) }}</div>
										</div>
										<div class="divider" v-if="!record.isBlocked"></div>
										<div class="d-flex justify-content-evenly mgt-16" v-if="!record.isBlocked">
												<button class="mdc-button"
													@click="patchLikeState(record.id, record.like,record);record.like = !record.like" @keypress="patchLikeState(record.id, record.like,record);record.like = !record.like" tabindex="0"
												>
														<span class="mdc-button__ripple"></span>
														<i class="material-icons mdc-button__icon t-color-red" aria-hidden="true">favorite</i>
														<span class="mdc-button__label t-body3 font-r t-color-iconInactive"
														:class="{ on: record.like }">{{ $t("1433") }}</span>
												</button>
												<button class="mdc-button" @click="moveToDetail(record)" @keypress="moveToDetail(record)" tabindex="0">
														<span class="mdc-button__ripple"></span>
														<i class="material-icons mdc-button__icon t-color-iconInactive"
																aria-hidden="true">chat_border</i>
														<span class="mdc-button__label t-body3 font-r t-color-iconInactive"
														>{{ $t("1434") }}</span>
												</button>
										</div>
								</div>
						<infinite-loading @infinite="fetchData" :identifier="infiniteId" spinner="spiral">
              <div slot="no-more" class="mgt-16"></div>
              <div slot="no-results" class="mgt-16"></div>
            </infinite-loading></div>
          </main>
      </div>
  </div>
</template>

<script>
// Components/Mixin/Extend/API define
import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "@/mixins/topAppBar.js";
import { MDCRipple } from "@material/ripple";
import { fileMixin } from "@/mixins/file.js";
import portfolioApi from "@/api/portfolioApi.js";
import NoData from "../common/NoDataSocialLearningLesson.vue";
import InfiniteLoading from "vue-infinite-loading";
import socialApi from "@/api/socialApi.js";
import TopAppBarDrawer from "../TopAppBarDrawer.vue";

export default {

  components: {
		NoData,
		InfiniteLoading,
		TopAppBar,
		TopAppBarDrawer
	},

	filters: {
		charLength(value) {
			if (value.length > 30) {
				return value.substring(0, 30) + "..";
			} else {
				return value;
			}
		},
	},

	data() {
		return {
			status: "",
			leftBtnMethod: () => {
				this.$router.go(-1);
			},
			isNoData: false,
			campaignData: null,
			listData: [],
			boardList: [],
			currentPage: 1,
			totalPages: 1,
			infiniteId: +new Date(),
			topTitle: localStorage.getItem('brandName'),
		};
	},

	mixins: [topAppBarMixin, fileMixin],

	computed: {},

	watch: {
		$route(to, from) {
			this.initData();
		},
	},

	mounted() {
		// 기본 파라미터 설정(set default parameter)
		this.setTopAppBarBackPortfolio(this.$t("1863"));
	},

	methods: {
		initData() {
			this.listData = [];
			this.currentPage = 1;
			this.totalPages = 1;
			this.infiniteId += 1;
		},
		// 목록 데이터 로딩(get list data)
		fetchData($state) {
			let responseData = null;
			let responseDatas = null;
			if (this.totalPages >= this.currentPage) {
				portfolioApi
					.likedSocialLessonList()
					.then((response) => {
						responseData = response.data.data;
						responseDatas = response.data;
						this.listData = this.listData.concat(responseDatas.data);
						this.currentPage++;
						this.totalPages = responseData.totalPages;

						if (responseData.length) {
							$state.loaded();
						} else {
							$state.complete();
						}
						if (this.listData.length > 0) {
							this.isNoData = false;
						} else {
							this.isNoData = true;
						}
					})
					.catch((err) => {
						//$state.error();
					});
			} else {
				$state.complete();
			}
		},

		listFilter(str) {
			let length = 90;
			let ending = ' ...';
			let str1='';
			if (str.length > length) {
				str1 = str.substring(0, length - ending.length) + ending;
				return str1.replace(/(\r\n|\n|\r)/gm, '<br/>')
			} else {
				return str.replace(/(\r\n|\n|\r)/gm, '<br/>');
			}
		},

    // method to redirect the user on Detail page if exists
		moveToDetail(record) {
			if (record && record.id) {
				if(record.status.value === 'HIDED' || record.authPermission.length <= 0 || !record.authPermission[0].access) {
				this.$alert({
					title: '',
					content: this.$t("3055"),
					accept: this.$t("3054"),
					})
					.then(() => {})
					.catch(() => {})
				} else {
				this.$router.push('/socialLearning/'+record.boardDto.identifier+'/'+record.id+'?boardName='+encodeURIComponent(record.boardDto.name)+'&likedSocial=true')
				}
			}
    },

		patchLikeState(id, status,record) {
			this.$showLoading();
			let action = status
				? socialApi.patchPostLike(record.boardDto.identifier, id)
				: socialApi.patchPostDislike(record.boardDto.identifier, id);

			action
				.then(response => {
					this.$hideLoading();
					record.likesCount = response.data.data.likesCount;
					this.initData();
					//this.detail.like = !status;
				})
				.catch(err => {
					this.$error({ content: err.errMsg }).then(() => {});
				});
		}
	},
};
</script>

<style scoped>
.mdc-elevation--z3 {
	border-radius: 4px;
	overflow: hidden;
	box-shadow: 0 1px 3px 0 var(--Shadow1);
	background-color: var(--DocumentWhite);
}
.tabs .tab {
	width: 50%;
}

.font-18 {
	font-size: 18px;
}
.card-bottom {
	border-top: 1px solid var(--Divider);
}
.w-195 {
	width: 195px !important;
	height: 195px !important;
	object-fit: cover;
}
.w-93 {
	width: 93px !important;
	height: 93px !important;
	object-fit: cover;
}
span.image-count {
	bottom: 0;
	right: 0;
	width: 93px;
	height: 93px;
	background: var(--Iconinactive);
}
html[dir="rtl"] span.image-count {
	left: 0;
}

</style>
